var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"image is-16by9"},[_c('screen',{attrs:{"idx":_vm.screenId,"forceOfferId":_vm.offerId,"forceTemplateId":_vm.templateId,"forceScreens":_vm.screens}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }